export enum GameIds {
    BigSmall = 1,
    SeDie = 2,
    FishPrawnCrab = 3,
    BigSmallTurbo = 4,
    DragonTiger = 7,
    KenoProMax = 8,
    MiniSeDie = 9,
    Baccarat = 10,
    KenoMini = 14,
    KenoMini2 = 15,
    KenoEast = 16,
    KenoWest = 17,
    KenoSouth = 18,
    KenoNorth = 19,
    VipSeDie = 22,
    SpecialSeDie = 24,
    VipBaccarat = 27,
    ThreeCards = 35,
    KenoSoccer = 36,
    KenoSoccer2 = 37,
    KenoPower1 = 40,
    KenoPower2 = 41,
    MegaKeno = 52,
    MegaKeno2 = 53,
}
